import "./style.css";

import Cabeleireira from "../../images/whoarewe/Screenshot_2.png";

export default function WhoAreWe(){
  return(
    <div className="whoarewe-container">
      <div className="whoarewe-items">
        <div className="whoarewe-text-container">
          <h2 className="whoarewe-title">Quem somos?</h2>
          <p className="whoarewe-text">
            No nosso salão, acreditamos que beleza vai além da aparência, é sobre sentir-se bem, elevar a autoestima e trazer leveza para o dia a dia. Nosso espaço é um refúgio de amor, paz e luz, onde cada pessoa é recebida com carinho e atenção.<br/>Mais do que transformar cabelos, queremos transformar momentos. Sabemos que, às vezes, o dia pode estar pesado, mas aqui, nosso propósito é fazer você sair mais feliz, mais confiante e se sentindo única.<br/>Prezamos a qualidade dos produtos, mas, acima de tudo, valorizamos o atendimento. Cada cliente é especial, e nossa missão é proporcionar uma experiência acolhedora, desde os pequenos até os mais experientes.<br/>Aqui, o cuidado vai além dos fios, é com você, com sua história, com seu brilho. Seja bem-vinda ao nosso espaço, onde cada detalhe é pensado com amor para você.
          </p>
        </div>
        <div className="whoarewe-photo">
          <img src={Cabeleireira} alt="Cabeleireira"/>
        </div>
      </div>
    </div>
  );
};